import {
  NOTIFICATION_ADD,
  NOTIFICATION_REMOVE } from './constants';
import mongoid from 'mongoid-js';

export const showNotification = (title, message, severity, delay = null) => ({
  type: NOTIFICATION_ADD, title, message, severity, delay, id: mongoid()
});
export const hideNotification = id => ({
  type: NOTIFICATION_REMOVE, id
});
